(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sticky-atc"] && !Shopify.designMode) return;
  try {
    (function () {
    function init() {
      document.querySelectorAll('.sticky-atc').forEach(function (bar) {
        var id = bar.dataset.sectionId;
        var stickyBtn = document.getElementById('StickyAtcButton-' + id);
        var priceTarget = document.getElementById('StickyAtcPrice-' + id);
        var realBtn = document.getElementById('ProductSubmitButton-' + id);
        var priceSource = document.getElementById('price-' + id);
        if (!stickyBtn || !realBtn) return;

        stickyBtn.addEventListener('click', function () {
          var b = document.getElementById('ProductSubmitButton-' + id);
          if (b) b.click();
        });

        // Sync the sticky button's label/disabled state from the real button.
        // Writes only to the sticky bar (which is NOT observed), so no feedback loop.
        function syncBtn() {
          var b = document.getElementById('ProductSubmitButton-' + id);
          if (!b) return;
          stickyBtn.disabled = b.hasAttribute('disabled');
          var span = b.querySelector('span:not(.visually-hidden)');
          var txt = (span ? span.textContent : b.textContent) || '';
          if (txt.trim()) stickyBtn.textContent = txt.trim();
        }

        // Mirror the live price from the source price node into the sticky bar.
        function syncPrice() {
          var ps = document.getElementById('price-' + id);
          if (ps && priceTarget) priceTarget.innerHTML = ps.innerHTML;
        }

        syncBtn();
        syncPrice();

        // Observe ONLY the source nodes (the real button and the price block),
        // never the bar's own container — otherwise updating the bar would
        // retrigger the observer in an infinite loop.
        new MutationObserver(syncBtn).observe(realBtn, { attributes: true, childList: true, subtree: true });
        if (priceSource) {
          new MutationObserver(syncPrice).observe(priceSource, { childList: true, subtree: true });
        }

        // Reveal the bar once the main add-to-cart button scrolls out of view.
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting) bar.setAttribute('hidden', '');
              else bar.removeAttribute('hidden');
            });
          }, { threshold: 0 }).observe(realBtn);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
